import React from "react"
import PropTypes from "prop-types"

import StepAddNumbers from "./components/StepAddNumbers"
import StepLevelCalls from "./components/StepLevelCalls"
import StepSchedule from "./components/StepSchedule"

const StepModals = ({ step, ...props }) => {
  const modals = {
    numbers: StepAddNumbers,
    level: StepLevelCalls,
    schedule: StepSchedule
  }
  const Component = modals[step]
  return <Component {...props} />
}
StepModals.propTypes = {
  step: PropTypes.string
}

export default StepModals



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/StepModals/index.js